<!-- TODO: column id (or other way) to tell how to style this cell -->
<div class="cell-container" [class.readonly]="readonly">
    <currency-input #input [value]="value" [readonly]="readonly" (valueChange)="_handleValueChange($event)" (focus)="_handleFocus($event)"
        (blur)="_handleBlur($event)" (keydown)="_handleKeydown($event)"></currency-input>
</div>